export const ATTRIBUTE_TYPES = {
  GRADUATION: "GRADUATION",
  YES_NO: "YES_NO",
  COLOR: "COLOR",
  TRAIT: "TRAIT",
  TEXT: "TEXT",
};

export const ATTRIBUTE_TYPE_LABEL = {
  GRADUATION: "GRADAÇÃO",
  YES_NO: "SIM/NÃO",
  COLOR: "COR",
  TRAIT: "CARACTERÍSTICA (AROMA, SABOR, ETC)",
  TEXT: "TEXTO",
};

export const ATTRIBUTE_TYPE_OPTIONS = Object.values(ATTRIBUTE_TYPES).map(at => 
  ({ label: ATTRIBUTE_TYPE_LABEL[at], value: at })
);

export const TRAIT_TYPES = {
  SELECT: "SELECT",
  COLOR: "COLOR",
  GRADUATION: "GRADUATION",
};

export const TRAIT_TYPE_LABEL = {
  SELECT: "SELEÇÃO SIMPLES",
  COLOR: "COR",
  GRADUATION: "GRADAÇÃO",
};

export const TRAIT_TYPE_OPTIONS = Object.values(TRAIT_TYPES).map(t => 
  ({ label: TRAIT_TYPE_LABEL[t], value: t })
);